module.exports = function getResource(label, vars = []) {
    let resources = {
        error: 'Error'
    };

    return resources[label];
};
